import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface PageViewAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  tenant: OD3_Tenant;
  hostname: string;
  pageName: string;
  path: string;
  sessionId: string;
  visitorId: string;
  userAgent: string;
  language: string;
  referrer: string;
  screenWidth: number;
  screenHeight: number;
  eventType: string;
  eventData?: string;
  duration?: number;
}

export class PageView extends Parse.Object<PageViewAttributes> {
  constructor(data?: Partial<PageViewAttributes>) {
    super("APP_PageView", data as PageViewAttributes);
  }
}

Parse.Object.registerSubclass("APP_PageView", PageView);
